import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/")({
  staticData: {
    title: "apps.resources",
  },
});
